import {JSX, useEffect} from "react";

const ScrollToTop: ({children}) => JSX.Element = ({children}) => {
    useEffect(() => {
        // due to unintended effect of clicking on link causing a component re-render,
        // react remembers previous scroll position so we have to reset it here.
        window.scrollTo(0, 0);
    }, []);

    return <>{children}</>
};

export default ScrollToTop;